'use client';

// import { useRef, useEffect } from 'react';
// import gsap from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import styles from './animatedimage.module.scss';

interface AnimatedImageProps {
    children: React.ReactNode;
    direction?: 'leftToRight' | 'rightToLeft';
}
// gsap.registerPlugin(ScrollTrigger);

export function AnimatedImage({ children /*, direction = 'leftToRight' */ }: AnimatedImageProps) {
    return children;

    // const containerRef = useRef<HTMLDivElement>(null);

    // useEffect(() => {
    //     if (containerRef.current) {
    //         const container = containerRef.current;
    //         const image = container.querySelector('img');

    //         if (image) {
    //             const tl = gsap.timeline({
    //                 scrollTrigger: {
    //                     trigger: container,
    //                     toggleActions: 'play none none none',
    //                 },
    //             });

    //             const setTween = tl.set(container, { autoAlpha: 1 });

    //             const xPercent = direction === 'leftToRight' ? -100 : 100;
    //             const fromToTweenContainer = tl.fromTo(
    //                 container,
    //                 {
    //                     xPercent: xPercent,
    //                 },
    //                 {
    //                     xPercent: 0,
    //                     duration: 1,
    //                     delay: 0.2,
    //                     ease: 'power2.out',
    //                 },
    //             );

    //             const fromToTweenImage = tl.fromTo(
    //                 image,
    //                 {
    //                     xPercent: -xPercent,
    //                 },

    //                 {
    //                     xPercent: 0,
    //                     duration: 1,
    //                     ease: 'power2.out',
    //                 },
    //                 `-=${1}`,
    //             );

    //             return () => {
    //                 tl.kill();
    //                 setTween.kill();
    //                 fromToTweenContainer.kill();
    //                 fromToTweenImage.kill();
    //             };
    //         }
    //     }
    // }, [direction]);
    // return (
    //     <div className={styles.revealMask} ref={containerRef}>
    //         {children}
    //     </div>
    // );
}
